import {
  SiteDuplicateCheck,
  DuplicateSite,
} from '@black-bear-energy/black-bear-energy-common'
import { DromoSiteRecord, SiteAction } from 'common/types'
import { AxiosInstance } from 'axios'
import { parseDuplicateCheckResults } from '../DromoUploader/parseDuplicateCheckResults'

export async function checkForDuplicates(
  sites: DromoSiteRecord[],
  clientId: number,
  api: AxiosInstance
) {
  const dupeCheckSites: SiteDuplicateCheck[] = sites
    .filter((site) => site.siteAction !== SiteAction.Ignore)
    .map((site) => getSiteDuplicateCheck(site))

  const dupeCheckResponse = await api.post<DuplicateSite[]>('/sites/dedupe', {
    clientId,
    sites: dupeCheckSites,
  })

  return parseDuplicateCheckResults(dupeCheckResponse.data, sites)
}

function getSiteDuplicateCheck(site: DromoSiteRecord): SiteDuplicateCheck {
  const siteAction = site.siteAction
  const existingSiteToModify = [SiteAction.Update, SiteAction.Sold].includes(
    siteAction
  )
    ? parseInt(site.existingRecordId as string)
    : undefined
  const buildingArea = site.buildingArea
    ? parseInt(site.buildingArea as string)
    : null
  return {
    id: site.rowId as string,
    clientDesignation: site.clientDesignation as string,
    name: site.name as string,
    streetAddress: site.address as string | undefined,
    state: site.state as string | undefined,
    latitude: site.latitude as number,
    longitude: site.longitude as number,
    buildingArea,
    existingSiteToModify,
  } satisfies SiteDuplicateCheck
}
